import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Alert, Snackbar } from '@mui/material';
import { logger } from '@utils/logger';
import {
  monitorLucidworksScript,
  setupGlobalLucidworksErrorHandler,
  createNetworkMonitor,
} from '@utils/lucidworksErrorHandler';

const LW_Embeddable = ({
  productId,
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [networkStatus, setNetworkStatus] = useState(navigator.onLine);
  const networkMonitorRef = useRef(null);
  const errorHandlerCleanupRef = useRef(null);
  // Use React's useEffect to inject styles properly
  React.useEffect(() => {
    // Add a style tag to hide the qna header if needed
    const styleEl = document.createElement('style');
    styleEl.textContent = `
    as-qna .as-chat-wrapper .answer-message .answer-bubble {
    background-color: #00a499;
    color: #fff;
    align-self: flex-start;
}

as-qna .as-chat-wrapper .answer-message .answer-icon {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMzInIGhlaWdodD0nMzInIHZpZXdCb3g9JzAgMCAzMiAzMicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cmVjdCB3aWR0aD0nMzInIGhlaWdodD0nMzInIHJ4PScxNicgZmlsbD0nIzAwYTQ5OScvPjxwYXRoIGQ9J00yMS4wMjU2IDIwLjU3NUwyMC41MTkzIDE5LjcxMjZDMjAuNDQ2MSAxOS43NTU2IDIwLjM3ODYgMTkuODA3OCAyMC4zMTg1IDE5Ljg2NzlMMjEuMDI1NiAyMC41NzVaTTE1LjYwMDYgMjEuODI2M0gxNi42MDA2QzE2LjYwMDYgMjEuMjk3IDE2LjE4ODIgMjAuODU5NCAxNS42NTk4IDIwLjgyOEwxNS42MDA2IDIxLjgyNjNaTTE1LjYwMDYgMjZIMTQuNjAwNkMxNC42MDA2IDI2LjQwNDQgMTQuODQ0MyAyNi43NjkxIDE1LjIxNzkgMjYuOTIzOEMxNS41OTE2IDI3LjA3ODYgMTYuMDIxNyAyNi45OTMxIDE2LjMwNzcgMjYuNzA3MUwxNS42MDA2IDI2Wk0yMy41NTUzIDE0LjkyMjFDMjMuNTU1MyAxNi44MzE0IDIyLjQxNTIgMTguNTk5NSAyMC41MTkzIDE5LjcxMjZMMjEuNTMxOSAyMS40MzczQzIzLjkwNzIgMjAuMDQyOCAyNS41NTUzIDE3LjY4MTggMjUuNTU1MyAxNC45MjIxSDIzLjU1NTNaTTE2LjIwNTQgOUMyMC40NDgzIDkgMjMuNTU1MyAxMS44MTg3IDIzLjU1NTMgMTQuOTIyMUgyNS41NTUzQzI1LjU1NTMgMTAuMzc5NSAyMS4xODU1IDcgMTYuMjA1NCA3VjlaTTguODU1NDcgMTQuOTIyMUM4Ljg1NTQ3IDExLjgxODcgMTEuOTYyNCA5IDE2LjIwNTQgOVY3QzExLjIyNTMgNyA2Ljg1NTQ3IDEwLjM3OTUgNi44NTU0NyAxNC45MjIxSDguODU1NDdaTTE1LjY1OTggMjAuODI4QzExLjY4NzYgMjAuNTkyMyA4Ljg1NTQ3IDE3Ljg5MTEgOC44NTU0NyAxNC45MjIxSDYuODU1NDdDNi44NTU0NyAxOS4yNjE4IDEwLjg1NTIgMjIuNTQ2NSAxNS41NDE0IDIyLjgyNDVMMTUuNjU5OCAyMC44MjhaTTE2LjYwMDYgMjZWMjEuODI2M0gxNC42MDA2VjI2SDE2LjYwMDZaTTIwLjMxODUgMTkuODY3OUwxNC44OTM1IDI1LjI5MjlMMTYuMzA3NyAyNi43MDcxTDIxLjczMjcgMjEuMjgyMUwyMC4zMTg1IDE5Ljg2NzlaJyBmaWxsPSd3aGl0ZScvPjwvc3ZnPgo=);
    background-repeat: no-repeat;
    width: 32px;
    height: 32px;
    min-width: 32px;
    margin-right: 16px;
    margin-top: 8px;
}

as-qna mo-search-bar {
    font-size: 14px;
    flex: 0 0 auto;
    margin: 0 32px 24px 32px;
    border: 1px solid #d7dbdf;
    border-radius: 24px;
    padding: 0 8px;
    min-height: 40px;
    background: transparent;
    visibility: hidden;
}
    as-qna .as-qna-container {
      height: auto;
      width: 100%;
      box-shadow: none;
      border: none;
      border-radius: 0px;
      background-color: transparent;
    }
    
    as-qna .as-qna-wrapper {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      min-height: 0;
      overflow: hidden;
      padding: 15px;
      margin-bottom: 0px;
      height: 100%;
    }

    as-qna .as-qna-wrapper .as-qna-header .as-qna-circle-icon {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMzInIGhlaWdodD0nMzInIHZpZXdCb3g9JzAgMCAzMiAzMicgZmlsbD0nbm9uZScgeG1zbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cmVjdCB3aWR0aD0nMzInIGhlaWdodD0nMzInIHJ4PScxNicgZmlsbD0nIzAwYTQ5OScvPjxwYXRoIGQ9J00yMS4wMjU2IDIwLjU3NUwyMC41MTkzIDE5LjcxMjZDMjAuNDQ2MSAxOS43NTU2IDIwLjM3ODYgMTkuODA3OCAyMC4zMTg1IDE5Ljg2NzlMMjEuMDI1NiAyMC41NzVaTTE1LjYwMDYgMjEuODI2M0gxNi42MDA2QzE2LjYwMDYgMjEuMjk3IDE2LjE4ODIgMjAuODU5NCAxNS42NTk4IDIwLjgyOEwxNS42MDA2IDIxLjgyNjNaTTE1LjYwMDYgMjZIMTQuNjAwNkMxNC42MDA2IDI2LjQwNDQgMTQuODQ0MyAyNi43NjkxIDE1LjIxNzkgMjYuOTIzOEMxNS41OTE2IDI3LjA3ODYgMTYuMDIxNyAyNi45OTMxIDE2LjMwNzcgMjYuNzA3MUwxNS42MDA2IDI2Wk0yMy41NTUzIDE0LjkyMjFDMjMuNTU1MyAxNi44MzE0IDIyLjQxNTIgMTguNTk5NSAyMC41MTkzIDE5LjcxMjZMMjEuNTMxOSAyMS40MzczQzIzLjkwNzIgMjAuMDQyOCAyNS41NTUzIDE3LjY4MTggMjUuNTU1MyAxNC45MjIxSDIzLjU1NTNaTTE2LjIwNTQgOUMyMC40NDgzIDkgMjMuNTU1MyAxMS44MTg3IDIzLjU1NTMgMTQuOTIyMUgyNS41NTUzQzI1LjU1NTMgMTAuMzc5NSAyMS4xODU1IDcgMTYuMjA1NCA3VjlaTTguODU1NDcgMTQuOTIyMUM4Ljg1NTQ3IDExLjgxODcgMTEuOTYyNCA5IDE2LjIwNTQgOVY3QzExLjIyNTMgNyA2Ljg1NTQ3IDEwLjM3OTUgNi44NTU0NyAxNC45MjIxSDguODU1NDdaTTE1LjY1OTggMjAuODI4QzExLjY4NzYgMjAuNTkyMyA4Ljg1NTQ3IDE3Ljg5MTEgOC44NTU0NyAxNC45MjIxSDYuODU1NDdDNi44NTU0NyAxOS4yNjE4IDEwLjg1NTIgMjIuNTQ2NSAxNS41NDE0IDIyLjgyNDVMMTUuNjU5OCAyMC44MjhaTTE2LjYwMDYgMjZWMjEuODI2M0gxNC42MDA2VjI2SDE2LjYwMDZaTTIwLjMxODUgMTkuODY3OUwxNC44OTM1IDI1LjI5MjlMMTYuMzA3NyAyNi43MDcxTDIxLjczMjcgMjEuMjgyMUwyMC4zMTg1IDE5Ljg2NzlaJyBmaWxsPSd3aGl0ZScvPjwvc3ZnPgo=);   background-repeat: no-repeat;
    background-size: 100px 40px;
    height: 40px;
    width: 100px;
    margin-bottom: 5px;
  }
    
    .as-qna-item-text {
      color: #00a499 !important;
      font-size: 18px !important;
    }

    as-qna .as-qna-wrapper .as-qna-list .as-qna-item .as-qna-item-icon {
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgZmlsbD0nbm9uZScgeG1zbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48Y2lyY2xlIGN4PScxMicgY3k9JzEyJyByPScxMS4yNScgc3Ryb2tlPScjMDBhNDk5JyBzdHJva2Utd2lkdGg9JzEuNScvPjxjaXJjbGUgY3g9JzEyJyBjeT0nOCcgcj0nMi4yNScgc3Ryb2tlPScjMDBhNDk5JyBzdHJva2Utd2lkdGg9JzEuNScvPjxwYXRoIGQ9J003Ljc1IDE3QzcuNzUgMTQuNjUyOCA5LjY1Mjc5IDEyLjc1IDEyIDEyLjc1QzE0LjM0NzIgMTIuNzUgMTYuMjUgMTQuNjUyOCAxNi4yNSAxN1YxNy45MzIyQzE2LjI1IDE4LjEwNzcgMTYuMTA3NyAxOC4yNSAxNS45MzIyIDE4LjI1SDguMDY3OEM3Ljg5MjI4IDE4LjI1IDcuNzUgMTguMTA3NyA3Ljc1IDE3LjkzMjJWMTdaJyBzdHJva2U9JyMwMGE0OTknIHN0cm9rZS13aWR0aD0nMS41Jy8+PC9zdmc+Cg==);
      background-repeat: no-repeat;
      height: 24px;
      width: 24px;
      min-width: 24px;
      margin-right: 8px;
    }

    as-qna .as-qna-wrapper .as-qna-body {
      display: flex;
      flex-direction: column;
      min-height: 350px;
      overflow: visible;
      height: 100%;
      padding: 5px 0;
    }
    
    as-qna .as-qna-wrapper .as-qna-header {
      display: flex;
      flex: 0 0 auto;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    
    lw-template {
      display: block;
      height: 100%;
      width: 100%;
    }

    `;
    document.head.appendChild(styleEl);

    // Cleanup function to remove the style tag when component unmounts
    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  // Enhanced useEffect for Lucidworks script monitoring and error handling
  useEffect(() => {
    let cleanup = null;

    const initializeErrorHandling = async () => {
      try {
        // Setup global error handler for Lucidworks
        const globalCleanup = setupGlobalLucidworksErrorHandler(
          (error, details) => {
            logger.error('Lucidworks error caught:', { error, details });
            setHasError(true);
            setErrorMessage(
              details.userMessage || 'An error occurred with the Q&A system'
            );
            setShowErrorSnackbar(true);
          }
        );
        errorHandlerCleanupRef.current = globalCleanup;

        // Setup network monitoring
        const networkMonitor = createNetworkMonitor((isOnline) => {
          setNetworkStatus(isOnline);
          if (!isOnline) {
            setHasError(true);
            setErrorMessage(
              'No internet connection. Q&A features may not work properly.'
            );
            setShowErrorSnackbar(true);
          }
        });
        networkMonitorRef.current = networkMonitor;

        // Monitor Lucidworks script loading
        const scriptMonitor = monitorLucidworksScript({
          onScriptLoaded: () => {
            logger.info('Lucidworks script loaded successfully');
            setHasError(false);
          },
          onScriptError: (error) => {
            logger.error('Lucidworks script failed to load:', error);
            setHasError(true);
            setErrorMessage(
              'Failed to load Q&A system. Please refresh the page.'
            );
            setShowErrorSnackbar(true);
          },
          onScriptTimeout: () => {
            logger.warn('Lucidworks script loading timeout');
            setHasError(true);
            setErrorMessage(
              'Q&A system is taking longer than expected to load.'
            );
            setShowErrorSnackbar(true);
          },
        });

        cleanup = () => {
          if (globalCleanup) globalCleanup();
          if (networkMonitor?.cleanup) networkMonitor.cleanup();
          if (scriptMonitor?.cleanup) scriptMonitor.cleanup();
        };
      } catch (error) {
        logger.error('Failed to initialize Lucidworks error handling:', error);
        setHasError(true);
        setErrorMessage('Failed to initialize Q&A system');
        setShowErrorSnackbar(true);
      }
    };

    initializeErrorHandling();

    return () => {
      if (cleanup) cleanup();
    };
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (errorHandlerCleanupRef.current) {
        errorHandlerCleanupRef.current();
      }
      if (networkMonitorRef.current?.cleanup) {
        networkMonitorRef.current.cleanup();
      }
    };
  }, []);

  const handleCloseErrorSnackbar = () => {
    setShowErrorSnackbar(false);
  };

  const handleRetry = () => {
    setHasError(false);
    setErrorMessage('');
    setShowErrorSnackbar(false);
    // Force reload of the component by updating key or remounting
    window.location.reload();
  };

  return (
    <Box>
      {hasError && !networkStatus && (
        <Alert
          severity='warning'
          sx={{ mb: 2 }}
          action={
            <button
              onClick={handleRetry}
              style={{
                background: 'none',
                border: 'none',
                color: '#00a499',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Retry
            </button>
          }
        >
          <Typography variant='body2'>
            Network connection issues detected. Q&A features may be limited.
          </Typography>
        </Alert>
      )}

      {hasError && networkStatus && (
        <Alert
          severity='error'
          sx={{ mb: 2 }}
          action={
            <button
              onClick={handleRetry}
              style={{
                background: 'none',
                border: 'none',
                color: '#d32f2f',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Retry
            </button>
          }
        >
          <Typography variant='body2'>{errorMessage}</Typography>
        </Alert>
      )}
      <lw-template
        id='26c193c1-29b2-4dd6-8bc8-a69259a35831'
        mock-mode='false'
        product-id={productId}
      ></lw-template>
      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseErrorSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseErrorSnackbar}
          severity={networkStatus ? 'error' : 'warning'}
          sx={{ width: '100%' }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LW_Embeddable;
